import { render, staticRenderFns } from "./DataLandList.vue?vue&type=template&id=2d1a46f6&scoped=true"
import script from "./DataLandList.vue?vue&type=script&lang=js"
export * from "./DataLandList.vue?vue&type=script&lang=js"
import style0 from "./DataLandList.vue?vue&type=style&index=0&id=2d1a46f6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d1a46f6",
  null
  
)

export default component.exports